import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-left-menu',
  templateUrl: './side-left-menu.component.html',
  styleUrl: './side-left-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideLeftMenuComponent implements OnInit, OnDestroy {
  @Input() menuSliderLeft = false;
  @Output() menuSliderLeftChange = new EventEmitter<boolean>();

  @ViewChild('sideMenuWrapper') sideMenuWrapper: ElementRef;

  private isAdmin = false;



  tabMenuLeft: boolean = true;
  menuItems: any = [];
  menuItem: any = {};
  menuItemsInfo: any = [
    {
      label: 'Info',
      collapseId: 'Info',
      iconClass: 'fa-solid fa-circle-info',
      subLinks: [
        {
          label: 'Roles',
          routerLink: '/roles',
          iconClass: 'fa-solid fa-globe side_icon',
        },
        {
          label: 'How To Earn',
          routerLink: '/how-to-earn',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Rental',
          routerLink: '/rental-system-terms-and-conditions',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Terms',
          routerLink: '/policies',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Kachiing Questions',
          routerLink: '/faq',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Version 1.3.0',
          routerLink: '/patch-Note',
          iconClass: 'fa-solid fa-question',
        },
      ],
    },
    {
      title: 'Main Pages',
    },
    {
      label: 'Forum',
      routerLink: '/forum',
      iconClass: 'fa-solid fa-comments',
    },
    // {
    //   label: 'Poll',
    //   routerLink: '/forum/poll',
    //   iconClass: 'fa-solid fa-square-poll-vertical',
    //   condition: 'admin',
    // },
    {
      label: 'Giveaway',
      routerLink: '/giveaway',
      iconClass: 'fa-solid fa-circle-dollar-to-slot',
      //condition: 'admin',
    },
    {
      label: 'Share News',
      routerLink: '/news',
      iconClass: 'fa-solid fa-newspaper',
    },
    {
      title: 'Other Pages',
      condition: 'auth',
    },
    {
      label: 'Rewards',
      routerLink: '/rewards',
      iconClass: 'fa-solid fa-store',
    },
    // {
    //   label: 'Rewards',
    //   routerLink: '/rewards',
    //   iconClass: "fa-solid fa-gift",
    //   condition: 'auth'
    // },
  ];



  imgUrl = environment.ImageUrl;
  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    public auth: AuthServiceService,
    private local: LocalServiceService,
    public sharedService: SharedService,
    public roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService
  ) { }
  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN')
    })
    this.fetch();

  }


  /*************************** Code related to keywords of subcagtegory******************************************* */

  public selectedCategoryTypesNameSuggestion = []



  public keywordsSelectedSubCategory = null;
  public keywordSSelectedSubCategoryKeywordList: string[] = [];
  public currentInputtingKeyword: string = '';


  private _getKeywordsOfCurrentSubCategory() {

    this.auth.getKeywordsOfSubCategory(this.keywordsSelectedSubCategory.id)
      .subscribe({
        next: data => {
          this.keywordSSelectedSubCategoryKeywordList = data.body;
        }
      })
  }

  @ViewChild('editSubCategoryKeywordModal')
  public editSubCategoryKeywordModal: ElementRef;

  public openEditSubCategoryKeywordModal(subCategory) {
    this.keywordsSelectedSubCategory = subCategory;
    this._getKeywordsOfCurrentSubCategory();
    this.modalService.open(this.editSubCategoryKeywordModal, { size: 'md' })
    this.auth.getTypesOfCategory(subCategory.id)
      .subscribe({
        next: (data: any) => {
          this.selectedCategoryTypesNameSuggestion = data.data.map(type => type.name)

        }
      })
  }
  public removeKeywordFromSelectedSubCategory(keyword: string) {
    this.local.confirmYesNo({
      title: "Remove keyword",
      text: `remove keyword ${keyword} from ${this.keywordsSelectedSubCategory.label}?`,
      icon: 'info'
    }).then(
      c => {
        if (c.isConfirmed) {
          this.auth.removeKeywordFromSubCategory(this.keywordsSelectedSubCategory.id, keyword)
            .subscribe({
              next: () => {
                this.toastr.success("Removed");
                this._getKeywordsOfCurrentSubCategory();
              },
              error: err => {
                console.error(err);
                this.toastr.error("Something went wrong while editing keywords")
              }
            }
            )

        }
      }
    )


  }
  private _addKeywordToSelectedSubCategory() {
    this.auth.addKeywordToSubCategory(this.keywordsSelectedSubCategory.id, this.currentInputtingKeyword)
      .subscribe({
        next: () => {
          this.currentInputtingKeyword = ''
          this.toastr.success("Added!");
          this._getKeywordsOfCurrentSubCategory();

        },
        error: err => {
          console.error(err);
          this.toastr.error("Something went wrong while editing keywords")
        }
      }
      )
  }
  public addKeywordToSelectedSubCategory() {
    this.auth.getSubCategoriesByKeyword(this.currentInputtingKeyword).subscribe({
      next: (data) => {
        if (data.body.length) {
          this.local.confirmYesNo({ text: `There are other(${data.body.length}) subcategories that use this keyword`, title: 'Are you sure you want to add keyword', icon: 'warning' })
            .then(r => {
              if (r.isConfirmed) {
                this._addKeywordToSelectedSubCategory();
              }
            })

        } else {
          this._addKeywordToSelectedSubCategory();

        }
      }
    })


  }
  /********************************************************************************************************************************* */
  icons: any = {
    'Food & Beverage': 'fa-solid fa-burger',
    'Home Dining': 'fa-solid fa-house-user',
    'Fitness': 'fa-solid fa-person-skating',
    'Pets': 'fa-solid fa-paw',
    'Education': 'fa-solid fa-school',
    'Child Care': 'fa-solid fa-child',
    'Home Improvement': 'fa-solid fa-house-chimney',
    'Beauty & Grooming': 'fa-solid fa-b',
    'Automobile & Transport': 'fa-solid fa-car',
    'Games and Hobbies': 'fa-solid fa-gamepad',
    'Others': 'fa-solid fa-ellipsis'
  }
  private _roleSubscription: Subscription | null = null;
  fetch() {
    this.commonService.categoryList.subscribe((categories) => {
    

      const menuItem = [];
      categories.map(async (e) => {
        menuItem.push({
          id: e.id,
          label: e.name,
          priority: e.priority, 
          collapseId: `menu-${e.id}`,
          iconClass: this.icons[e.name],
          image: e.image,
          subLinks: [{ id: e.id, label: e.name, routerLink: `category/${e.slug}`, }, ...e.subCategory.map((sub) => ({
            id: sub.categorieChildId,
            label: sub.categoryName, 
            routerLink: `category/${sub.slug}`,
          })),]
        });
      });
      this.menuItems = [...menuItem, ...this.menuItems];
      // this.menuItems.sort((a,b) =>{
      //   const aVal = a.priority ? 1 : 0;
      //   const bVal = b.priority ? 1 : 0;
      //   return bVal - aVal 
      // })

      // this.menuItems.sort(
      //   (a, b) =>{
      //     //console.log(a, 'vs', b)
      //     const indexA = this.commonService.catPriority.indexOf(a.label)
      //     const indexB = this.commonService.catPriority.indexOf(b.label)

          
      //     if(indexA >= 0 && indexB >=0){
      //      // console.log('cool')
      //       return (indexA - indexB )
      //     }else if(indexA >= 0){
      //       return -1
      //     }else if(indexB >=0){
      //       return 1
      //     }
      //     return a.label.localeCompare(a.label)
      //   }
      // )

      this.cdr.detectChanges()
    })



    this.local.getUserDetailsObserver().subscribe((user) => {

      var isLogin;
      const u = this.local.getUser();
      if (u) {
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
      // console.log('login =', this.local.getUser(), user)
      // console.log('login = ', this.isLogin)
      this.menuItemsInfo = this.menuItemsInfo.map((item) => {

        let condition = true
        if (item.condition === 'auth') {
          condition = this.isLogin;
        } else if (item.condition === 'admin') {
          //console.log('checking is the user is admin', this.isUserAdmin)
          condition = this.isLogin && this.isUserAdmin;
        }
        return {
          ...item,
          condition
        };
      });
      this.cdr.detectChanges()
    });
  }
  public isLogin: any = false;

  ngOnChanges(changes): void {
    if (changes['menuSliderLeft'] && this.menuSliderLeft && !this.menuItems.length) {
      this.fetch()
    }
  }
  public get isUserAdmin(): boolean {
    return this.isAdmin;
  }
  public selectedPriorityCat = {id: null, priority: 0};
  public setPriorityForSelectedCat(){
     console.log('selectedCat', this.selectedPriorityCat)
    this.auth.setCategoryPriority(this.selectedPriorityCat?.id, this.selectedPriorityCat?.priority)
    .subscribe(()=>{
      this.menuItems = []
      this.commonService.getCommonRequireData() //refresh
      this.modalService.dismissAll()

    })
  }
  public trackMenuItems(item){
    return item.id
  }
  public openPriorityBox(modalTemplate, cat){
    this.selectedPriorityCat = cat
     const ref =  this.modalService.open(modalTemplate, {size: 'sm'})
     console.log('selectedCat', this.selectedPriorityCat)
   

  }
}
